const carSpecs: { [model: string]: { [key: string]: { wltp: number; speed: string; topSpeed?: string } } } = {
    S: {
        'long-range': {
            wltp: 634,
            speed: '3,2',
        },
        plaid: {
            wltp: 600,
            speed: '2,1',
        },
    },
    '3': {
        'rear-wheel-drive': {
            wltp: 554,
            speed: '6,1',
        },
        'long-range-rwd': {
            wltp: 634,
            speed: '5.9',
        },
        'long-range': {
            wltp: 678,
            speed: '4,4',
        },
        performance: {
            wltp: 547,
            speed: '3,3',
        },
        'performance-awd': {
            wltp: 528,
            speed: '3,1',
            topSpeed: '262',
        },
        'single-motor': {
            wltp: 620,
            speed: '5,9',
        },
    },
    X: {
        'long-range': {
            wltp: 576,
            speed: '3,9',
        },
        plaid: {
            wltp: 543,
            speed: '2,6',
        },
    },
    Y: {
        'rear-wheel-drive': {
            wltp: 455,
            speed: '6,9',
            topSpeed: '217',
        },
        'long-range-rwd': {
            wltp: 600,
            speed: '5,9',
            topSpeed: '217',
        },
        'long-range': {
            wltp: 533,
            speed: '5,0',
            topSpeed: '217',
        },
        performance: {
            wltp: 514,
            speed: '3,7',
            topSpeed: '250',
        },
    },
}

export default {
    en: {
        'deal-option-edition-title': 'Edition',
    },

    da: {
        // Edition
        'deal-option-edition-title': 'Udgave',
        'deal-option-edition-optionDescription-tesla.model_3.standard_range_plus_rwd': `Rækkevidde ${carSpecs['3']['rear-wheel-drive'].wltp}km (WLTP), 0-100 km / t på ${carSpecs['3']['rear-wheel-drive'].speed} sekunder, delvist premium interiør`,
        'deal-option-edition-optionDescription-tesla.model_3.long_range_dual_motor_awd': `Rækkevidde ${carSpecs['3']['long-range'].wltp}km (WLTP), 0-100 km / t på ${carSpecs['3']['long-range'].speed} sekunder, premium interiør`,
        'deal-option-edition-optionDescription-tesla.model_3.performance_dual_motor_awd': `Rækkevidde ${carSpecs['3']['performance'].wltp}km (WLTP), 0-100 km / t på ${carSpecs['3']['performance'].speed} sekunder, premium interiør`,
        'deal-option-edition-optionDescription-tesla.model_3.performance_awd': `Rækkevidde ${carSpecs['3']['performance-awd'].wltp}km (WLTP), 0-100 km / t på ${carSpecs['3']['performance-awd'].speed} sekunder, premium interiør`,
        'deal-option-edition-optionDescription-tesla.model_y.rear_wheel_drive': `Rækkevidde ${carSpecs['Y']['rear-wheel-drive'].wltp}km (WLTP), 0-100 km / t på ${carSpecs['Y']['rear-wheel-drive'].speed} sekunder, premium interiør`,
        'deal-option-edition-optionDescription-tesla.model_y.long_range_rwd': `Rækkevidde ${carSpecs['Y']['long-range-rwd'].wltp}km (WLTP), 0-100 km / t på ${carSpecs['Y']['long-range-rwd'].speed} sekunder, premium interiør`,
        'deal-option-edition-optionDescription-tesla.model_y.long_range': `Rækkevidde ${carSpecs['Y']['long-range'].wltp}km (WLTP), 0-100 km / t på ${carSpecs['Y']['long-range'].speed} sekunder, premium interiør`,
        'deal-option-edition-optionDescription-tesla.model_y.performance': `Rækkevidde ${carSpecs['Y']['performance'].wltp}km (WLTP), 0-100 km / t på ${carSpecs['Y']['performance'].speed} sekunder, premium interiør`,
        'deal-option-edition-optionDescription-tesla.model_x.long_range': `Rækkevidde ${carSpecs['X']['long-range'].wltp}km (WLTP), 0-100 km / t på ${carSpecs['X']['long-range'].speed} sekunder, premium interiør`,
        'deal-option-edition-optionDescription-tesla.model_x.performance': `Rækkevidde ${carSpecs['X']['plaid'].wltp}km (WLTP), 0-100 km / t på ${carSpecs['X']['plaid'].speed} sekunder, premium interiør`,
        'deal-option-edition-optionDescription-tesla.model_s.long_range': `Rækkevidde ${carSpecs['S']['long-range'].wltp}km (WLTP), 0-100 km / t på ${carSpecs['S']['long-range'].speed} sekunder, premium interiør`,
        'deal-option-edition-optionDescription-tesla.model_s.performance': `Rækkevidde ${carSpecs['S']['plaid'].wltp}km, 0-100 km / t på ${carSpecs['S']['plaid'].speed} sekunder, premium interiør`,

        // Paint
        'deal-option-paint-title': 'Farve',

        // Rims
        'deal-option-rims-title': 'Fælge',

        // Steering wheel
        'deal-option-steeringWheel-title': 'Rat',

        // Interior
        'deal-option-interior-title': 'Interiør',
        'deal-option-interior-optionLabel-tesla.model_3.standard_range_plus_rwd.black': 'Helt sort',
        'deal-option-interior-optionLabel-tesla.model_3.standard_range_plus_rwd.black__white': 'Sort og hvid',
        'deal-option-interior-optionLabel-tesla.model_3.long_range_dual_motor_awd.black': 'Helt sort',
        'deal-option-interior-optionLabel-tesla.model_3.long_range_dual_motor_awd.black__white': 'Sort og hvid',
        'deal-option-interior-optionLabel-tesla.model_3.performance_dual_motor_awd.black': 'Helt sort',
        'deal-option-interior-optionLabel-tesla.model_3.performance_dual_motor_awd.black__white': 'Sort og hvid',

        // Autopilot
        'deal-option-autopilot-title': 'Autopilot',
        'deal-option-autopilot-subtitle':
            'Vælg her, om du vil have en autopilot (standard) eller en fuldt autonom køreevne.',

        // Tow hitch
        'deal-option-towhitch-title': 'Anhængertræk',
        'deal-option-towhitch-subtitle':
            'Tilføj et stærkt anhængertræk i stål med aftagelig adapter. Kan ikke eftermonteres efter køretøjet er leveret.',
        'deal-option-towhitch-checkboxLabel': 'Anhængertræk',
        'deal-option-towhitch-optionLabel-Towing Package': 'Anhängerkupplung enthalten',
        'deal-option-towhitch-optionLabel-No Towing Package': 'Uden anhængertræk',
        'deal-option-towhitch-sidebar-included': 'Anhængertræk',
        'deal-option-towhitch-sidebar-not-included': 'Ingen anhængertræk',

        // Winter tires
        'deal-option-winterTires-title': 'Vinterdæk',
        'deal-option-winterTires-subtitle': 'Dækkene skiftes to gange om året og vi står for opbevaring',
        'deal-option-winterTires-checkboxLabel': 'Tilføj vinterdæk',
        'deal-option-winterTires-optionLabel-Winter Tire Package': 'Tilføj vinterdæk',
        'deal-option-winterTires-optionLabel-No Winter Tire Package': 'Ingeng vinterdæk',
        'deal-option-winterTires-sidebar-included': 'Inkluderet',
        'deal-option-winterTires-sidebar-not-included': 'Ikke inkluderet',

        // Premium connectivity
        'deal-option-premiumConnectivity-title': 'Premium connectivity',
        'deal-option-premiumConnectivity-subtitle': 'Tilføj Teslas Premium Forbindelse',
        'deal-option-premiumConnectivity-checkboxLabel': 'Premium connectivity',
        'deal-option-premiumConnectivity-optionLabel-Premium Connectivity Package': 'Ja',
        'deal-option-premiumConnectivity-optionLabel-No Premium Connectivity Package': 'Ny',
        'deal-option-premiumConnectivity-sidebar-included': 'Inkluderet',
        'deal-option-premiumConnectivity-sidebar-not-included': 'Ikke inkluderet',

        // Mileage
        'deal-option-mileage-title': 'Antal kilometer om året',

        // Duration
        'deal-option-duration-title': 'Kontraktperiode',

        // Downpayment
        'deal-option-downpayment-title': 'Førstegangsydelse',
        'deal-option-downpayment-subtitle': 'Vælg din ønskede førstegangsydelse her. Dette er ikke et depositum!',

        // Deductible
        'deal-option-deductible-title': 'Selvrisiko',
        'deal-option-deductible-subtitle': 'Sænk din selvrisiko',
        'deal-option-deductible-checkboxLabel': 'Sænk din selvrisiko',
        'deal-option-deductible-optionLabel-Lager Eigen Risico': 'Med en lavere fradragsberettiget',
        'deal-option-deductible-optionLabel-No Lager Eigen Risico': 'Uden lavere fradragsberettiget',
        'deal-option-deductible-sidebar-included': 'Sænket',
        'deal-option-deductible-sidebar-not-included': 'Standard',

        // Leasing type
        'deal-option-leasingType-title': 'Leje form',
        'deal-option-leasingType-optionLabel-full_operational_lease': 'Erhvervsleasing',

        // Seating
        'deal-option-seating-title': 'Sæder',

        // Additional details
        'deal-option-optionsDescription-title': 'Andre muligheder',
    },

    de: {
        // Edition
        'deal-option-edition-title': 'Auflage',
        'deal-option-edition-optionDescription-tesla.model_3.standard_range_plus_rwd': `Reichweite ${carSpecs['3']['rear-wheel-drive'].wltp}km (WLTP), 0-100 km / h in ${carSpecs['3']['rear-wheel-drive'].speed} Sekunden, Premium Interieur teilweise`,
        'deal-option-edition-optionDescription-tesla.model_3.long_range_dual_motor_awd': `Reichweite ${carSpecs['3']['long-range'].wltp}km (WLTP), 0-100 km / h in ${carSpecs['3']['long-range'].speed} Sekunden, Premium Interieur`,
        'deal-option-edition-optionDescription-tesla.model_3.performance_dual_motor_awd': `Reichweite ${carSpecs['3']['performance'].wltp}km (WLTP), 0-100 km / h in ${carSpecs['3']['performance'].speed} Sekunden, Premium Interieur`,
        'deal-option-edition-optionDescription-tesla.model_3.performance__awd': `Reichweite ${carSpecs['3']['performance-awd'].wltp}km (WLTP), 0-100 km / h in ${carSpecs['3']['performance-awd'].speed} Sekunden, Premium Interieur`,
        'deal-option-edition-optionDescription-tesla.model_3.long_range_rwd': `Reichweite ${carSpecs['3']['long-range-rwd'].wltp}km (WLTP), 0-100 km / h in ${carSpecs['3']['long-range-rwd'].speed} Sekunden, Premium Interieur`,
        'deal-option-edition-optionDescription-tesla.model_3.long_range_single_motor_rwd': `Reichweite ${carSpecs['3']['single-motor'].wltp}km (WLTP), 0-100 km / h in ${carSpecs['3']['single-motor'].speed} Sekunden, Premium Interieur teilweise`,
        'deal-option-edition-optionDescription-tesla.model_y.rear_wheel_drive': `Reichweite ${carSpecs['Y']['rear-wheel-drive'].wltp}km (WLTP), 0-100 km / h in ${carSpecs['Y']['rear-wheel-drive'].speed} Sekunden, Premium Interieur`,
        'deal-option-edition-optionDescription-tesla.model_y.long_range_rwd': `Reichweite ${carSpecs['Y']['long-range-rwd'].wltp}km (WLTP), 0-100 km / h in ${carSpecs['Y']['long-range-rwd'].speed} Sekunden, Premium Interieur`,
        'deal-option-edition-optionDescription-tesla.model_y.long_range': `Reichweite ${carSpecs['Y']['long-range'].wltp}km (WLTP), 0-100 km / h in ${carSpecs['Y']['long-range'].speed} Sekunden, Premium Interieur`,
        'deal-option-edition-optionDescription-tesla.model_y.performance': `Reichweite ${carSpecs['Y']['performance'].wltp}km (WLTP), 0-100 km / h in ${carSpecs['Y']['performance'].speed} Sekunden, Premium Interieur`,
        'deal-option-edition-optionDescription-tesla.model_x.long_range': `Reichweite ${carSpecs['X']['long-range'].wltp}km (WLTP), 0-100 km / h in ${carSpecs['X']['long-range'].speed} Sekunden, Premium Interieur`,
        'deal-option-edition-optionDescription-tesla.model_x.plaid': `Reichweite ${carSpecs['X']['plaid'].wltp}km (WLTP), 0-100 km / h in ${carSpecs['X']['plaid'].speed} Sekunden, Premium Interieur`,
        'deal-option-edition-optionDescription-tesla.model_s.long_range': `Reichweite ${carSpecs['S']['long-range'].wltp}km (WLTP), 0-100 km / h in ${carSpecs['S']['long-range'].speed} Sekunden, Premium Interieur`,
        'deal-option-edition-optionDescription-tesla.model_s.plaid': `Reichweite ${carSpecs['S']['plaid'].wltp}km, 0-100 km / h in ${carSpecs['S']['plaid'].speed} Sekunden, Premium Interieur`,

        // Paint
        'deal-option-paint-title': 'Farbe',

        // Rims
        'deal-option-rims-title': 'Felgen',

        // Steering wheel
        'deal-option-steeringWheel-title': 'Lenkrad',

        // Interior
        'deal-option-interior-title': 'Innenraum',
        'deal-option-interior-optionLabel-tesla.model_3.standard_range_plus_rwd.black': 'Komplett schwarz',
        'deal-option-interior-optionLabel-tesla.model_3.standard_range_plus_rwd.black__white': 'Schwarz und weiß',
        'deal-option-interior-optionLabel-tesla.model_3.long_range_dual_motor_awd.black': 'Komplett schwarz',
        'deal-option-interior-optionLabel-tesla.model_3.long_range_dual_motor_awd.black__white': 'Schwarz und weiß',
        'deal-option-interior-optionLabel-tesla.model_3.performance_dual_motor_awd.black': 'Komplett schwarz',
        'deal-option-interior-optionLabel-tesla.model_3.performance_dual_motor_awd.black__white': 'Schwarz und weiß',
        'deal-option-interior-optionLabel-tesla.model_3.long_range_rwd.black': 'Komplett schwarz',
        'deal-option-interior-optionLabel-tesla.model_3.long_range_rwd.black__white': 'Schwarz und weiß',

        // Accessories

        // Extra long cable
        'deal-option-accessory_extra_long_cable-checkboxLabel': 'Langes ladekabel',
        'deal-option-accessory_extra_long_cable-optionDescription-checkbox_description': '',
        'deal-option-accessory_extra_long_cable-sidebar-included': 'Langes ladekabel',
        'deal-option-accessory_extra_long_cable-sidebar-not-included': 'Kein(e) langes ladekabel',

        // Bicycle carrier
        'deal-option-accessory_bicycle_carrier-checkboxLabel': 'Anhängerkupplungstäger',
        'deal-option-accessory_bicycle_carrier-optionDescription-checkbox_description': '',
        'deal-option-accessory_bicycle_carrier-sidebar-included': 'Anhängerkupplungstäger',
        'deal-option-accessory_bicycle_carrier-sidebar-not-included': 'Kein(e) Anhängerkupplungstäger',

        // CCS Adapter
        'deal-option-accessory_ccs_adapter-checkboxLabel': 'CCS -Adapter',
        'deal-option-accessory_ccs_adapter-optionDescription-checkbox_description': '',
        'deal-option-accessory_ccs_adapter-sidebar-included': 'CCS -Adapter',
        'deal-option-accessory_ccs_adapter-sidebar-not-included': 'Kein(e) CCS -Adapter',

        // Home charge cable
        'deal-option-accessory_home_charge_cable-checkboxLabel': 'Heimladekabel',
        'deal-option-accessory_home_charge_cable-optionDescription-checkbox_description': '',
        'deal-option-accessory_home_charge_cable-sidebar-included': 'Heimladekabel',
        'deal-option-accessory_home_charge_cable-sidebar-not-included': 'Kein(e) heimladekabel',

        // Home charge cable
        'deal-option-accessory_roof_rack-checkboxLabel': 'Dachgepäckträger',
        'deal-option-accessory_roof_rack-optionDescription-checkbox_description': '',
        'deal-option-accessory_roof_rack-sidebar-included': 'Dachgepäckträger',
        'deal-option-accessory_roof_rack-sidebar-not-included': 'Kein(e) dachgepäckträger',

        // Towhitch
        'deal-option-accessory_towhitch-checkboxLabel': 'Anhängerkupplung',
        'deal-option-accessory_towhitch-optionDescription-checkbox_description':
            'Rüsten Sie Ihr Auto mit einer abnehmbaren Anhängerkupplung aus. Bei Bedarf kann die Anhängerkupplung auch nach der Auslieferung des Fahrzeugs geliefert werden.',
        'deal-option-accessory_towhitch-sidebar-included': 'Anhängerkupplung',
        'deal-option-accessory_towhitch-sidebar-not-included': 'Kein(e) anhängerkupplung',

        // Tesla wall connector
        'deal-option-accessory_tesla_wall_connector-checkboxLabel': 'Tesla Wandladestation (Wall Connector)',
        'deal-option-accessory_tesla_wall_connector-optionDescription-checkbox_description': '',
        'deal-option-accessory_tesla_wall_connector-sidebar-included': 'Tesla Wandladestation (Wall Connector)',
        'deal-option-accessory_tesla_wall_connector-sidebar-not-included':
            'Kein(e) tesla Wandladestation (Wall Connector)',

        // Autopilot
        'deal-option-autopilot-title': 'Autopilot',
        'deal-option-autopilot-subtitle': 'Wählen Sie zwischen dem Autopilot und dem Full Self-Driving Paket.',

        // Tow hitch
        'deal-option-towhitch-title': 'Anhängerkupplung',
        'deal-option-towhitch-subtitle':
            'Rüsten Sie Ihr Auto mit einer abnehmbaren Anhängerkupplung aus. Bei Bedarf kann die Anhängerkupplung auch nach der Auslieferung des Fahrzeugs geliefert werden.',
        'deal-option-towhitch-checkboxLabel': 'Anhängerkupplung',
        'deal-option-towhitch-optionLabel-Towing Package': 'Anhängerkupplung enthalten',
        'deal-option-towhitch-optionLabel-No Towing Package': 'Ohne Anhängerkupplung',
        'deal-option-towhitch-sidebar-included': 'Anhängerkupplung',
        'deal-option-towhitch-sidebar-not-included': 'Ohne Anhängerkupplung',

        // Winter tires
        'deal-option-winterTires-title': 'Winterreifenpaket',
        'deal-option-winterTires-subtitle':
            'Das Paket behaltet, einen passenden Winterreifensatz, die Einlagerung der Sommerreifen, sowie die anfallenden Montagekosten.',
        'deal-option-winterTires-checkboxLabel': 'Winterreifenpaket',
        'deal-option-winterTires-optionLabel-Winter Tire Package': 'Winterreifenpaket',
        'deal-option-winterTires-optionLabel-No Winter Tire Package': 'Ohne Winterreifenpaket',
        'deal-option-winterTires-sidebar-included': 'Einschließlich',
        'deal-option-winterTires-sidebar-not-included': 'Nicht enthalten',

        // Premium connectivity
        'deal-option-premiumConnectivity-title': 'Premium Konnektivität',
        'deal-option-premiumConnectivity-subtitle': 'Fügen Sie die Premium Konnektivität von Tesla hinzu',
        'deal-option-premiumConnectivity-checkboxLabel': 'Premium Konnektivität',
        'deal-option-premiumConnectivity-optionLabel-Premium Connectivity Package': 'Ja',
        'deal-option-premiumConnectivity-optionLabel-No Premium Connectivity Package': 'Nein',
        'deal-option-premiumConnectivity-sidebar-included': 'Einschließlich',
        'deal-option-premiumConnectivity-sidebar-not-included': 'Nicht enthalten',

        // Mileage
        'deal-option-mileage-title': 'Fahrleistung pro Jahr',

        // Duration
        'deal-option-duration-title': 'Vertragslaufzeit',

        // Downpayment
        'deal-option-downpayment-title': 'Anzahlung',
        'deal-option-downpayment-subtitle':
            'Wählen Sie Ihre gewünschte Anzahlung. Die Höhe der Anzahlung wirkt sich entsprechend positiv auf Ihre monatliche Leasingrate aus.',

        // Deductible
        'deal-option-deductible-title': 'Eigenes Risiko',
        'deal-option-deductible-subtitle':
            'Senken Sie den Selbstbehalt für einen nicht behebbaren Vorfall von 350 Euro auf 150 Euro.',
        'deal-option-deductible-checkboxLabel': 'Unterer Selbstbehalt',
        'deal-option-deductible-optionLabel-Lager Eigen Risico': 'Mit einem niedrigeren Selbstbehalt',
        'deal-option-deductible-optionLabel-No Lager Eigen Risico': 'Ohne niedrigeren Selbstbehalt',
        'deal-option-deductible-sidebar-included': '150 €',
        'deal-option-deductible-sidebar-not-included': '350 €',

        // Leasing type
        'deal-option-leasingType-title': 'Leasingart',
        'deal-option-leasingType-optionLabel-full_operational_lease': 'All-inclusive Leasing',

        // Seating
        'deal-option-seating-title': 'Sitze',

        // Additional details
        'deal-option-optionsDescription-title': 'Andere optionen',
    },
    fr: {
        // Edition
        'deal-option-edition-title': 'Version',
        'deal-option-edition-optionDescription-tesla.model_3.standard_range_plus_rwd': `Autonomie ${carSpecs['3']['rear-wheel-drive'].wltp}km (WLTP), 0-100 km/h en ${carSpecs['3']['rear-wheel-drive'].speed} secondes, intérieur Prémium partiel`,
        'deal-option-edition-optionDescription-tesla.model_3.long_range_dual_motor_awd': `Autonomie ${carSpecs['3']['long-range'].wltp}km (WLTP), 0-100 km/h en ${carSpecs['3']['long-range'].speed} secondes, intérieur Prémium`,
        'deal-option-edition-optionDescription-tesla.model_3.performance_dual_motor_awd': `Autonomie ${carSpecs['3']['performance'].wltp}km (WLTP), 0-100 km/h en ${carSpecs['3']['performance'].speed} secondes, intérieur Prémium`,
        'deal-option-edition-optionDescription-tesla.model_3.performance_awd': `Autonomie ${carSpecs['3']['performance-awd'].wltp}km (WLTP), 0-100 km/h en ${carSpecs['3']['performance-awd'].speed} secondes, intérieur Prémium`,
        'deal-option-edition-optionDescription-tesla.model_3.long_range_rwd': `Autonomie ${carSpecs['3']['long-range-rwd'].wltp}km (WLTP), 0-100 km/h en ${carSpecs['3']['long-range-rwd'].speed} secondes, intérieur Prémium`,
        'deal-option-edition-optionDescription-tesla.model_y.rear_wheel_drive': `Autonomie ${carSpecs['Y']['rear-wheel-drive'].wltp}km (WLTP), 0-100 km/h en ${carSpecs['Y']['rear-wheel-drive'].speed} secondes, intérieur Prémium`,
        'deal-option-edition-optionDescription-tesla.model_y.long_range_rwd': `Autonomie ${carSpecs['Y']['long-range-rwd'].wltp}km (WLTP), 0-100 km/h en ${carSpecs['Y']['long-range-rwd'].speed} secondes, intérieur Prémium`,
        'deal-option-edition-optionDescription-tesla.model_y.long_range': `Autonomie ${carSpecs['Y']['long-range'].wltp}km (WLTP), 0-100 km/h en ${carSpecs['Y']['long-range'].speed} secondes, intérieur Prémium`,
        'deal-option-edition-optionDescription-tesla.model_y.performance': `Autonomie ${carSpecs['Y']['performance'].wltp}km (WLTP), 0-100 km/h en ${carSpecs['Y']['performance'].speed} secondes, intérieur Prémium`,
        'deal-option-edition-optionDescription-tesla.model_x.long_range': `Autonomie ${carSpecs['X']['long-range'].wltp}km (WLTP), 0-100 km/h en ${carSpecs['X']['long-range'].speed} secondes, intérieur Prémium`,
        'deal-option-edition-optionDescription-tesla.model_x.performance': `Autonomie ${carSpecs['X']['plaid'].wltp}km (WLTP), 0-100 km/h en ${carSpecs['X']['plaid'].speed} secondes, intérieur Prémium`,
        'deal-option-edition-optionDescription-tesla.model_s.long_range': `Autonomie ${carSpecs['S']['long-range'].wltp}km (WLTP), 0-100 km/h en ${carSpecs['S']['long-range'].speed} secondes, intérieur Prémium`,
        'deal-option-edition-optionDescription-tesla.model_s.performance': `Autonomie ${carSpecs['S']['plaid'].wltp}km, 0-100 km/h en ${carSpecs['S']['plaid'].speed} secondes, intérieur Prémium`,

        // Paint
        'deal-option-paint-title': 'Couleur',

        // Rims
        'deal-option-rims-title': 'Jantes',

        // Steering wheel
        'deal-option-steeringWheel-title': 'Volant',
        'deal-option-steeringWheel-steering-wheel': 'Volant Standard',
        'deal-option-steeringWheel-yoke-steering': 'Volant Yoke',
        'deal-option-steeringWheel-yoke-steering-description':
            'Vous pouvez acheter un volant rond pour 900€ TVAC après livraison.',
        'deal-option-steeringWheel-steering-wheel-description':
            'Il n’est pas possible de changer le volant standard après livraison',

        // Interior
        'deal-option-interior-title': 'Intérieur',
        'deal-option-interior-optionLabel-tesla.model_3.standard_range_plus_rwd.black': 'Noir intégral',
        'deal-option-interior-optionLabel-tesla.model_3.standard_range_plus_rwd.black__white': 'Noir et blanc',
        'deal-option-interior-optionLabel-tesla.model_3.long_range_dual_motor_awd.black': 'Noir intégral',
        'deal-option-interior-optionLabel-tesla.model_3.long_range_dual_motor_awd.black__white': 'Noir et blanc',
        'deal-option-interior-optionLabel-tesla.model_3.performance_dual_motor_awd.black': 'Noir intégral',
        'deal-option-interior-optionLabel-tesla.model_3.performance_dual_motor_awd.black__white': 'Noir et blanc',
        'deal-option-interior-optionLabel-tesla.model_3.long_range_rwd.black': 'Noir intégral',
        'deal-option-interior-optionLabel-tesla.model_3.long_range_rwd.black__white': 'Noir et blanc',

        //Accessories

        // Towhitch
        'deal-option-accessory_towhitch-checkboxLabel': 'Attache remorque',
        'deal-option-accessory_towhitch-optionDescription-checkbox_description': `Equipez votre voiture d'une barre d'attelage amovible. Si nécessaire, la barre d'attelage peut également être livrée après la livraison de la voiture.`,
        'deal-option-accessory_towhitch-sidebar-included': 'Attache remorque',
        'deal-option-accessory_towhitch-sidebar-not-included': `Pas d'attache remorque`,

        // Autopilot
        'deal-option-autopilot-title': 'Pilote automatique',
        'deal-option-autopilot-subtitle':
            'Choisissez ici si vous voulez le pilote automatique (standard) ou la capacité de conduite entièrement autonome.',

        // Model 3
        'deal-option-autopilot-optionLabel-tesla.model_3.standard_range_plus_rwd.full_self_driving_capability__meegroei_model':
            'Full Self-Driving Capability - Modèle évolutif',
        'deal-option-autopilot-optionLabel-tesla.model_3.long_range_dual_motor_awd.full_self_driving_capability__meegroei_model':
            'Full Self-Driving Capability - Modèle évolutif',
        'deal-option-autopilot-optionLabel-tesla.model_3.performance_dual_motor_awd.full_self_driving_capability__meegroei_model':
            'Full Self-Driving Capability - Modèle évolutif',

        // Model Y
        'deal-option-autopilot-optionLabel-tesla.model_y.rear_wheel_drive.full_self_driving_capability__meegroei_model':
            'Full Self-Driving Capability - Modèle évolutif',
        'deal-option-autopilot-optionLabel-tesla.model_y.long_range.full_self_driving_capability__meegroei_model':
            'Full Self-Driving Capability - Modèle évolutif',
        'deal-option-autopilot-optionLabel-tesla.model_y.performance.full_self_driving_capability__meegroei_model':
            'Full Self-Driving Capability - Modèle évolutif',

        // Tow hitch
        'deal-option-towhitch-title': 'Options',
        'deal-option-towhitch-subtitle':
            "Equipez votre voiture d'une barre d'attelage amovible. Si nécessaire, la barre d'attelage peut également être livrée après la livraison de la voiture.",
        'deal-option-towhitch-checkboxLabel': 'Crochet d’attelage',

        // Winter tires
        'deal-option-winterTires-title': 'Kit hivers',
        'deal-option-winterTires-subtitle':
            'Kit pneus hivers: les pneus sont montés sur les jantes d’origine. Le stockage est fait au sein de notre réseau de centrales de pneus.',
        'deal-option-winterTires-checkboxLabel': 'Kit hivers',
        'deal-option-winterTires-sidebar-included': 'Inclus',
        'deal-option-winterTires-sidebar-not-included': 'Non inclus',

        // Premium connectivity
        'deal-option-premiumConnectivity-title': 'Premium connectivité',
        'deal-option-premiumConnectivity-subtitle': 'Ajoutez la connectivité Premium de Tesla',
        'deal-option-premiumConnectivity-checkboxLabel': 'Premium connectivité',
        'deal-option-premiumConnectivity-optionLabel-Premium Connectivity Package': 'Non',
        'deal-option-premiumConnectivity-optionLabel-No Premium Connectivity Package': 'Qui',
        'deal-option-premiumConnectivity-sidebar-included': 'Inclus',
        'deal-option-premiumConnectivity-sidebar-not-included': 'Non inclus',

        // Mileage
        'deal-option-mileage-title': 'Nombre de kilomètres par an',

        // Duration
        'deal-option-duration-title': 'Durée du contrat',

        // Downpayment
        'deal-option-downpayment-title': 'Acompte',
        'deal-option-downpayment-subtitle': 'Sélectionnez ici l’acompte que vous souhaitez effectuer.',

        // Deductible
        'deal-option-deductible-title': 'Franchise',
        'deal-option-deductible-subtitle':
            'Baisser la franchise pour un événement non récupérable de 350 euros à 150 euros.',
        'deal-option-deductible-checkboxLabel': 'Déductible inférieure',
        'deal-option-deductible-optionLabel-Lager Eigen Risico': 'Avec une déductible inférieure',
        'deal-option-deductible-optionLabel-No Lager Eigen Risico': 'Sans déductible inférieure',
        'deal-option-deductible-sidebar-included': '150 €',
        'deal-option-deductible-sidebar-not-included': '350 €',

        //BE-fr deductible hardcoded
        'deal-option-deductible-be': '2.5% valeur catalogue',

        // Leasing type
        'deal-option-leasingType-title': 'Type',
        'deal-option-leasingType-optionLabel-full_operational_lease': 'Leasing Opérationnel',

        // Seating
        'deal-option-seating-title': 'Sièges',

        // Additional details
        'deal-option-optionsDescription-title': 'Autres options',
    },

    nl: {
        // Edition
        'deal-option-edition-title': 'Uitvoering',
        'deal-option-edition-optionDescription-tesla.model_3.standard_range_plus_rwd': `Bereik ${carSpecs['3']['rear-wheel-drive'].wltp}km (WLTP), 0-100 km/u in ${carSpecs['3']['rear-wheel-drive'].speed} seconden, gedeeltelijk premium interieur`,
        'deal-option-edition-optionDescription-tesla.model_3.long_range_dual_motor_awd': `Bereik ${carSpecs['3']['long-range'].wltp}km (WLTP), 0-100 km/u in ${carSpecs['3']['long-range'].speed} seconden, premium interieur`,
        'deal-option-edition-optionDescription-tesla.model_3.performance_dual_motor_awd': `Bereik ${carSpecs['3']['performance'].wltp}km (WLTP), 0-100 km/u in ${carSpecs['3']['performance'].speed} seconden, premium interieur`,
        'deal-option-edition-optionDescription-tesla.model_3.performance_awd': `Bereik ${carSpecs['3']['performance-awd'].wltp}km (WLTP), 0-100 km/u in ${carSpecs['3']['performance-awd'].speed} seconden, premium interieur`,
        'deal-option-edition-optionDescription-tesla.model_3.long_range_rwd': `Bereik ${carSpecs['3']['long-range-rwd'].wltp}km (WLTP), 0-100 km/u in ${carSpecs['3']['long-range-rwd'].speed} seconden, premium interieur`,
        'deal-option-edition-optionDescription-tesla.model_y.rear_wheel_drive': `Bereik ${carSpecs['Y']['rear-wheel-drive'].wltp}km (WLTP-schatting), 0-100 km/u in ${carSpecs['Y']['rear-wheel-drive'].speed} seconden, topsnelheid ${carSpecs['Y']['rear-wheel-drive'].topSpeed} km/u, premium interieur`,
        'deal-option-edition-optionDescription-tesla.model_y.long_range_rwd': `Bereik ${carSpecs['Y']['long-range-rwd'].wltp}km (WLTP-schatting), 0-100 km/u in ${carSpecs['Y']['long-range-rwd'].speed} seconden, topsnelheid ${carSpecs['Y']['long-range-rwd'].topSpeed} km/u, premium interieur`,
        'deal-option-edition-optionDescription-tesla.model_y.long_range': `Bereik ${carSpecs['Y']['long-range'].wltp}km (WLTP-schatting), 0-100 km/u in ${carSpecs['Y']['long-range'].speed} seconden, topsnelheid ${carSpecs['Y']['long-range'].topSpeed} km/u, premium interieur`,
        'deal-option-edition-optionDescription-tesla.model_y.performance': `Bereik ${carSpecs['Y']['performance'].wltp}km (WLTP-schatting), 0-100 km/u in ${carSpecs['Y']['performance'].speed} seconden, topsnelheid ${carSpecs['Y']['performance'].topSpeed} km/u, premium interieur`,
        'deal-option-edition-optionDescription-tesla.model_x.long_range': `Bereik ${carSpecs['X']['long-range'].wltp}km (WLTP-schatting), 0-100 km/u in ${carSpecs['X']['long-range'].speed} seconden, topsnelheid 250 km/u, premium interieur`,
        'deal-option-edition-optionDescription-tesla.model_x.performance': `Bereik ${carSpecs['X']['plaid'].wltp}km (geschat bereik), 0-100 km/u in ${carSpecs['X']['plaid'].speed} seconden, topsnelheid 262 km/u, premium interieur`,
        'deal-option-edition-optionDescription-tesla.model_s.long_range': `Bereik ${carSpecs['S']['long-range'].wltp}km (WLTP-schatting), 0-100 km/u in ${carSpecs['S']['long-range'].speed} seconden, topsnelheid 250 km/u, premium interieur`,
        'deal-option-edition-optionDescription-tesla.model_s.performance': `Bereik ${carSpecs['S']['plaid'].wltp}km (geschat bereik), 0-100 km/u in ${carSpecs['S']['plaid'].speed} seconden, topsnelheid 322 km/u, premium interieur`,

        // Paint
        'deal-option-paint-title': 'Kleur',

        // Rims
        'deal-option-rims-title': 'Velgen',

        // Steering wheel
        'deal-option-steeringWheel-title': 'Stuur',
        'deal-option-steeringWheel-yoke-steering': 'Yoke stuur',
        'deal-option-steeringWheel-steering-wheel': 'Standaard stuur',
        'deal-option-steeringWheel-yoke-steering-description':
            'Een Yoke stuur is no joke. Deze kan na aflevering wel nog vervangen worden door een standaard stuurwiel voor €900 incl. btw.',
        'deal-option-steeringWheel-steering-wheel-description':
            'Een standaard stuur, zoals je m kent, kan na aflevering niet worden gewisseld naar een ander type stuur.',

        // Interior
        'deal-option-interior-title': 'Interieur',
        'deal-option-interior-optionLabel-tesla.model_3.standard_range_plus_rwd.black': 'Volledig zwart',
        'deal-option-interior-optionLabel-tesla.model_3.standard_range_plus_rwd.black__white': 'Zwart en wit',
        'deal-option-interior-optionLabel-tesla.model_3.long_range_dual_motor_awd.black': 'Volledig zwart',
        'deal-option-interior-optionLabel-tesla.model_3.long_range_dual_motor_awd.black__white': 'Zwart en wit',
        'deal-option-interior-optionLabel-tesla.model_3.performance_dual_motor_awd.black': 'Volledig zwart',
        'deal-option-interior-optionLabel-tesla.model_3.performance_dual_motor_awd.black__white': 'Zwart en wit',
        'deal-option-interior-optionLabel-tesla.model_3.long_range_rwd.black': 'Volledig zwart',
        'deal-option-interior-optionLabel-tesla.model_3.long_range_rwd.black__white': 'Zwart en wit',

        // Accessories

        // Extra long cable
        'deal-option-accessory_extra_long_cable-checkboxLabel': 'Lange laadkabel',
        'deal-option-accessory_extra_long_cable-optionDescription-checkbox_description':
            'Extra lange kabel zodat je ook als de laadpaal wat verder weg staat gewoon kunt laden',
        'deal-option-accessory_extra_long_cable-sidebar-included': 'Lange laadkabel',
        'deal-option-accessory_extra_long_cable-sidebar-not-included': 'Geen lange laadkabel',

        // Bicycle carrier
        'deal-option-accessory_bicycle_carrier-checkboxLabel': 'Fietsendrager',
        'deal-option-accessory_bicycle_carrier-optionDescription-checkbox_description':
            'Met een maximaal draagvermogen van 68 kg is de dakdrager voor Model S ,3 & ,Y vanaf het begin ontworpen en technisch uitgewerkt voor maximale aerodynamische efficiëntie, minimaal interieurgeluid en een minimale invloed op het bereik. Het uiterst gestroomlijnde bevestigingsmechanisme kan gemakkelijk thuis worden gemonteerd en sluit naadloos aan. Extra toebehoren zoals skihouders, fietsendragers en bagageboxen kunnen naadloos gemonteerd worden.',
        'deal-option-accessory_bicycle_carrier-sidebar-included': 'Fietsendrager',
        'deal-option-accessory_bicycle_carrier-sidebar-not-included': 'Geen fietsendrager',

        // CCS Adapter
        'deal-option-accessory_ccs_adapter-checkboxLabel': 'CCS Combo 2 Adapter',
        'deal-option-accessory_ccs_adapter-optionDescription-checkbox_description':
            "(alleen voor Model S/X - Zorgt ervoor dat je met jouw Model S of X bij elke Tesla Supercharger locatie kunt laden maar ook alle andere snellaadlocaties verspreid door Europa. (werkt alleen als je ook de CCS upgrade hebt laten uitvoeren bij een Tesla Service Center) / Opmerking: de Model S/X CCS - Pre-Refresh is compatibel met Model SX-auto's die vóór juni 2016 zijn geleverd. De Model S CCS - Refresh is compatibel met Model S/X -auto's die na juni 2016 zijn geleverd.",
        'deal-option-accessory_ccs_adapter-sidebar-included': 'CCS Combo 2 Adapter',
        'deal-option-accessory_ccs_adapter-sidebar-not-included': 'Geen CCS Combo 2 Adapter',

        // Home charge cable
        'deal-option-accessory_home_charge_cable-checkboxLabel': 'Thuislaadkabel (Tesla Mobile connector)',
        'deal-option-accessory_home_charge_cable-optionDescription-checkbox_description':
            'Soms is er geen laadpaal in de buurt, hiermee kun je via het stopcontact in 24h jouw Tesla opladen. Ook handig voor vakanties!',
        'deal-option-accessory_home_charge_cable-sidebar-included': 'Thuislaadkabel',
        'deal-option-accessory_home_charge_cable-sidebar-not-included': 'Geen thuislaadkabel',

        // Home charge cable
        'deal-option-accessory_roof_rack-checkboxLabel': 'Dakdragers',
        'deal-option-accessory_roof_rack-optionDescription-checkbox_description':
            'Met een maximaal draagvermogen van 68 kg is de dakdrager voor Model S (Model S heeft wat pros en cons en voorwaarden),3 & ,Y)  vanaf het begin ontworpen en technisch uitgewerkt voor maximale aerodynamische efficiëntie, minimaal interieurgeluid en een minimale invloed op het bereik. Het uiterst gestroomlijnde bevestigingsmechanisme kan gemakkelijk thuis worden gemonteerd en sluit naadloos aan. Extra toebehoren zoals skihouders, fietsendragers en bagageboxen kunnen naadloos gemonteerd worden.',
        'deal-option-accessory_roof_rack-sidebar-included': 'Dakdragers',
        'deal-option-accessory_roof_rack-sidebar-not-included': 'Geen dakdragers',

        // Towhitch
        'deal-option-accessory_towhitch-checkboxLabel': 'Trekhaak',
        'deal-option-accessory_towhitch-optionDescription-checkbox_description':
            'Rust je auto uit met een afneembare trekhaak. Indien gewenst kan de trekhaak ook na levering van de auto geleverd worden.',
        'deal-option-accessory_towhitch-sidebar-included': 'Trekhaak',
        'deal-option-accessory_towhitch-sidebar-not-included': 'Geen trekhaak',

        // Tesla wall connector
        'deal-option-accessory_tesla_wall_connector-checkboxLabel': 'Tesla wall connector',
        'deal-option-accessory_tesla_wall_connector-optionDescription-checkbox_description':
            "De ideale en mooiste laadoplossing voor jouw Tesla, thuis of op kantoor! Met een laadkabel van 7,3m laadt je jouw Tesla met 71 km per uur op. Wall Connectors kunnen stroom delen om de elektrische capaciteit te maximaliseren en zo meerdere auto's tegelijkertijd op te laden.",
        'deal-option-accessory_tesla_wall_connector-sidebar-included': 'Tesla wall connector',
        'deal-option-accessory_tesla_wall_connector-sidebar-not-included': 'Geen tesla wall connector',

        // Autopilot
        'deal-option-autopilot-title': 'Autopilot',
        'deal-option-autopilot-optionDescription-fsd':
            'Full Self-Driving wordt geactiveerd na levering, zodat de kosten buiten de bijtelling vallen.',
        'deal-option-autopilot-optionDescription-growth-model':
            'De Full Self-Driving software van Tesla is best wel spannend. MisterGreen gelooft dat autonoom rijden de toekomst is en wil dit voor iedereen toegankelijk maken. Met het Full Self-Driving meegroeimodel stap je in voor een laag maandbedrag en groeit je maandbedrag met de ontwikkeling van de software mee. Je gaat pas meer betalen als er nieuwe functionaliteiten beschikbaar zijn.',

        // Tow hitch
        'deal-option-towhitch-title': 'Trekhaak',
        'deal-option-towhitch-subtitle':
            'Rust je auto uit met een afneembare trekhaak. Indien gewenst kan de trekhaak ook na levering van de auto geleverd worden.',
        'deal-option-towhitch-checkboxLabel': 'Trekhaak',
        'deal-option-towhitch-optionLabel-Towing Package': 'Trekhaak inbegrepen',
        'deal-option-towhitch-optionLabel-No Towing Package': 'Zonder trekhaak',
        'deal-option-towhitch-sidebar-included': 'Trekhaak',
        'deal-option-towhitch-sidebar-not-included': 'Geen trekhaak',

        // Winter tires
        'deal-option-winterTires-title': 'Winterbanden',
        'deal-option-winterTires-subtitle': 'De banden worden 2 keer per jaar op de velg gewisseld en opgeslagen.',
        'deal-option-winterTires-checkboxLabel': 'Winter Tire Package',
        'deal-option-winterTires-optionLabel-Winter Tire Package': 'Winter Tire Package',
        'deal-option-winterTires-optionLabel-No Winter Tire Package': 'Zonder winterpakket',
        'deal-option-winterTires-sidebar-included': 'Inbegrepen',
        'deal-option-winterTires-sidebar-not-included': 'Niet inbegrepen',

        // Premium connectivity
        'deal-option-premiumConnectivity-title': 'Premium connectiviteit',
        'deal-option-premiumConnectivity-subtitle': "Voeg Tesla's Premium connectivity toe. Voor meer informatie, zie ",
        'deal-option-premiumConnectivity-subtitleLink':
            'https://support.mistergreen.nl/nl/premium-connectivity-bij-lease-tesla',
        'deal-option-premiumConnectivity-subtitleLinkLabel': 'onze FAQ.',
        'deal-option-premiumConnectivity-checkboxLabel': 'Premium connectiviteit',
        'deal-option-premiumConnectivity-optionLabel-Premium Connectivity Package': 'Ja',
        'deal-option-premiumConnectivity-optionLabel-No Premium Connectivity Package': 'Nee',
        'deal-option-premiumConnectivity-sidebar-included': 'Inbegrepen',
        'deal-option-premiumConnectivity-sidebar-not-included': 'Niet inbegrepen',

        // Mileage
        'deal-option-mileage-title': 'Aantal kilometers per jaar',

        // Duration
        'deal-option-duration-title': 'Looptijd contract',

        // Downpayment
        'deal-option-downpayment-title': 'Eerste leasevergoeding',
        'deal-option-downpayment-subtitle':
            "Selecteer hier de eerste leasevergoeding die je wilt plaatsen. Klik op de 'i' links voor meer informatie.",

        // Deductible
        'deal-option-deductible-title': 'Eigen risico',

        // Leaving this as an example for possible approach to translating deducible options
        'deal-option-deductible-optionLabel-tesla.model_3.performance_awd.higher_rate': 'Hoger eigen risico',

        'deal-option-deductible-subtitle':
            'Verlaag het eigen risico van een niet verhaalbaar incident van 350 euro naar 150 euro.',
        'deal-option-deductible-checkboxLabel': 'Lager eigen risico',
        'deal-option-deductible-optionLabel-Lager Eigen Risico': 'Met lager eigen risico',
        'deal-option-deductible-optionLabel-No Lager Eigen Risico': 'Zonder lager eigen risico',
        'deal-option-deductible-sidebar-included': '€ 150',
        'deal-option-deductible-sidebar-not-included': '€ 350',

        //BE-nl deductible hardcoded
        'deal-option-deductible-be': '2.5% cataloguswaarde',

        // Leasing type
        'deal-option-leasingType-title': 'Leasevorm',
        'deal-option-leasingType-optionLabel-full_operational_lease': 'Full Operational Lease',
        'deal-option-leasingType-optionLabel-private_lease': 'Private Lease',

        // Seating
        'deal-option-seating-title': 'Zitplaatsen',

        // Additional details
        'deal-option-optionsDescription-title': 'Overige opties',
    },
}
